import { render, staticRenderFns } from "./OffSiteLocation.vue?vue&type=template&id=354ec4c5"
import script from "./OffSiteLocation.vue?vue&type=script&lang=js"
export * from "./OffSiteLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports